import { API_RESPONSE_CACHE_ENDPOINTS, API_RESPONSE_PROTOCOL_VERSION } from "../api-response-cache-kinds";
import { PULSE_RESPONSE_PATHS } from "../pulse-request";

export const TABLE_RESPONSE_CACHE_DB = "frogstat-table-responses";
export const TABLE_RESPONSE_CACHE_IDENTITY_HEADER = "X-FrogStat-Cache-Identity";
export const TABLE_RESPONSE_CACHE_MAX_BYTES = 64 * 1024 * 1024;
export const TABLE_RESPONSE_CACHE_MAX_ENTRY_BYTES = 16 * 1024 * 1024;
export const TABLE_RESPONSE_CACHE_MAX_ENTRIES = 64;
export const TABLE_RESPONSE_CACHE_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;
// Чтение стоит перед сетью; UI ждёт очистку не дольше этого бюджета.
export const TABLE_RESPONSE_CACHE_IO_TIMEOUT_MS = 250;
// Запись/очистка могут завершиться в фоне. Включает очередь IDB и занятый main thread.
export const TABLE_RESPONSE_CACHE_WRITE_TIMEOUT_MS = 10_000;
// Первый запуск storage-service браузера заметно медленнее чтения готовой БД.
export const TABLE_RESPONSE_CACHE_OPEN_TIMEOUT_MS = 1_500;
const PATHS = new Set<string>([...Object.values(API_RESPONSE_CACHE_ENDPOINTS), ...PULSE_RESPONSE_PATHS]);

export type TableResponseMetadata = {
  key: string;
  identity: string;
  etag: string;
  bytes: number;
  protocol: number;
  savedAt: number;
  usedAt: number;
  requestedAt: number;
};

/** Только разрешённые GET с явным scope. Ключи/сессии сюда не попадают. */
export function canPersistTableResponse(url: string, identity?: string): identity is string {
  if (!identity || !url.startsWith("/api/")) return false;
  try {
    const ids: unknown = JSON.parse(identity);
    const parsed = new URL(url, "https://cache.invalid");
    return Array.isArray(ids) && ids.length === 2 && ids.every(id => typeof id === "string" && id.length > 0 && !id.startsWith("public-page:"))
      && PATHS.has(parsed.pathname) && !!parsed.searchParams.get("stores") && !parsed.hash;
  } catch { return false; }
}

export function usableTableResponse(meta: TableResponseMetadata, now: number): boolean {
  return !!meta && meta.protocol === API_RESPONSE_PROTOCOL_VERSION && typeof meta.etag === "string"
    && /^W\/"[a-f0-9]{64}"$/.test(meta.etag) && Number.isFinite(meta.bytes) && meta.bytes > 0
    && meta.bytes <= TABLE_RESPONSE_CACHE_MAX_ENTRY_BYTES && Number.isFinite(meta.savedAt)
    && meta.savedAt <= now && now - meta.savedAt < TABLE_RESPONSE_CACHE_MAX_AGE_MS
    && Number.isFinite(meta.usedAt) && Number.isFinite(meta.requestedAt);
}

/** Выбор вытеснения только по маленьким метаданным, без чтения всех тел. */
export function tableResponseEvictions(entries: TableResponseMetadata[], incoming: TableResponseMetadata, now: number): string[] {
  const remove = entries.filter(entry => entry.key !== incoming.key && !usableTableResponse(entry, now)).map(entry => entry.key);
  const live = entries.filter(entry => entry.key !== incoming.key && usableTableResponse(entry, now)).sort((a, b) => a.usedAt - b.usedAt);
  let bytes = live.reduce((sum, entry) => sum + entry.bytes, incoming.bytes);
  let count = live.length + 1;
  for (const entry of live) {
    if (bytes <= TABLE_RESPONSE_CACHE_MAX_BYTES && count <= TABLE_RESPONSE_CACHE_MAX_ENTRIES) break;
    remove.push(entry.key);
    bytes -= entry.bytes;
    count--;
  }
  return remove;
}
